var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect5, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.386719,
    width: 350,
    height: 233,
    fill: "#E09064"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 225.623,
    y: 142.832,
    width: 4.61155,
    height: 19.9459,
    rx: 2.30577,
    transform: "rotate(34.148 225.623 142.832)",
    fill: "#E8E4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.61155,
    height: 20.6395,
    rx: 2.30577,
    transform: "matrix(-0.827591 0.561332 0.561332 0.827591 301.17 142.254)",
    fill: "#E8E4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 219.605,
    y: 151.535,
    width: 87.9452,
    height: 4.61155,
    rx: 2.30577,
    fill: "#E8E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.466 151.535H227.529C227.037 151.535 226.639 151.934 226.639 152.426C226.639 152.693 226.757 152.95 226.971 153.111C227.792 153.728 228.665 154.075 231.62 154.075C234.327 154.075 276.848 154.061 297.77 154.075C299.119 154.075 299.813 153.728 300.298 153.201C300.451 153.036 300.518 152.812 300.518 152.587C300.518 152.006 300.047 151.535 299.466 151.535Z",
    fill: "#C2BBEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.62 83.7094C226.23 76.4579 232.293 70.8828 239.57 70.8828H287.611C294.889 70.8828 300.952 76.4579 301.562 83.7094L306.124 137.949C306.811 146.115 300.369 153.122 292.174 153.122H235.008C226.813 153.122 220.371 146.115 221.058 137.949L225.62 83.7094Z",
    fill: "#6053B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.615 70.8828H247.148L305.613 131.713L301.565 83.7066C300.954 76.4563 294.891 70.8828 287.615 70.8828Z",
    fill: "#493AA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.042 87.9669C233.274 84.8337 235.884 82.4102 239.025 82.4102H288.156C291.297 82.4102 293.907 84.8338 294.139 87.9669L296.325 117.471C296.582 120.95 293.829 123.914 290.341 123.914H236.84C233.351 123.914 230.598 120.95 230.856 117.471L233.042 87.9669Z",
    fill: "#C7C1EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.153 82.4102H258.225L294.729 120.145C295.379 120.817 296.513 120.308 296.445 119.376L294.137 87.9704C293.906 84.8357 291.296 82.4102 288.153 82.4102Z",
    fill: "#B0A8E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.851 123.914L241.557 82.4102H248.011L259.425 123.914H252.851Z",
    fill: "#DCD7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.967 123.914L252.553 82.4102H254.405L265.64 123.914H263.967Z",
    fill: "#DCD7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 248.988,
    y: 74.1289,
    width: 29.2065,
    height: 6.07968,
    rx: 1,
    fill: "#27145C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.194 79.2086V75.1289C278.194 74.5766 277.746 74.1289 277.194 74.1289H250.297L255.851 79.9019C256.039 80.0978 256.299 80.2086 256.571 80.2086H277.194C277.746 80.2086 278.194 79.7609 278.194 79.2086Z",
    fill: "#1F0E4F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.902 139.817L221.407 133.773H305.799L306.3 139.817H220.902Z",
    fill: "#362B79"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 136.795,
    r: 5.93932,
    fill: "#6053B5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.318,
    cy: 136.795,
    r: 5.93932,
    fill: "#6053B5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.864,
    cy: 136.798,
    r: 4.63782,
    fill: "#362B79"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.319,
    cy: 136.798,
    r: 4.63782,
    fill: "#362B79"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 137.06,
    r: 4.37662,
    fill: "#C7C1EB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.318,
    cy: 137.06,
    r: 4.37662,
    fill: "#C7C1EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.285 78.8252V75.4648H259.603C260.367 75.4648 260.805 75.9359 260.805 76.5973C260.805 77.268 260.36 77.7298 259.585 77.7298H258.981V78.8252H258.285ZM258.981 77.1682H259.473C259.886 77.1682 260.088 76.9362 260.086 76.5973C260.088 76.2632 259.886 76.0381 259.473 76.0357H258.981V77.1682Z",
    fill: "#6F66A9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.478 78.867C261.26 78.867 261.084 78.6929 261.089 78.4771C261.084 78.2636 261.26 78.0895 261.478 78.0919C261.685 78.0895 261.864 78.2636 261.864 78.4771C261.864 78.6929 261.685 78.867 261.478 78.867Z",
    fill: "#6F66A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.43 78.8252V75.4648H263.748C264.512 75.4648 264.95 75.9359 264.95 76.5973C264.95 77.268 264.505 77.7298 263.729 77.7298H263.126V78.8252H262.43ZM263.126 77.1682H263.618C264.031 77.1682 264.233 76.9362 264.231 76.5973C264.233 76.2632 264.031 76.0381 263.618 76.0357H263.126V77.1682Z",
    fill: "#6F66A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M266.064 75.4648V78.8252H265.377V75.4648H266.064Z",
    fill: "#6F66A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M267.74 78.8762C266.967 78.8739 266.493 78.375 266.496 77.5767C266.493 76.7992 266.974 76.2724 267.712 76.2724C268.373 76.2724 268.895 76.6902 268.895 77.5488V77.7438H267.173C267.173 78.1243 267.398 78.3587 267.754 78.3611C267.988 78.3587 268.155 78.2566 268.222 78.1058H268.877C268.779 78.5722 268.362 78.8739 267.74 78.8762ZM267.173 77.3121H268.246C268.243 77.0058 268.032 76.7853 267.726 76.7876C267.41 76.7853 267.187 77.022 267.173 77.3121Z",
    fill: "#6F66A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport02);
export default __webpack_public_path__ + "static/media/transport_02.6b2b24ed3d179cdfb592239acfa77ca8.svg";
export { ForwardRef as ReactComponent };